import {combineReducers} from "redux";
import InvoiceListReducer from "./invoice-list/InvoiceListReducer";
import InvoiceDetailReducer from "./invoice-detail/InvoiceDetailReducer";
import CustomerReducer from "./customer/CustomerReducer";
import AuthReducer from "./login/AuthReducer";
import CustomerOrderNumberReducer from "./customer-order-number/CustomerOrderNumberReducer";


const rootReducer = combineReducers({
    invoiceList: InvoiceListReducer,
    invoiceDetail: InvoiceDetailReducer,
    customers: CustomerReducer,
    auth: AuthReducer,
    customerOrderNumbers: CustomerOrderNumberReducer
})

export default rootReducer;
